var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-expansion-panel',[_c('v-expansion-panel-header',{attrs:{"color":"green lighten-4"}},[_vm._v(" Productos ")]),_c('v-expansion-panel-content',[_c('v-data-table',{staticClass:"elevation-1 mt-2",attrs:{"dense":"","mobile-breakpoint":"0","headers":_vm.headers,"items":_vm.items},scopedSlots:_vm._u([{key:"item.importe",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(_vm._f("moneda")(item.importe)))]}},{key:"item.precio",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(_vm._f("moneda")(item.precio)))]}}],null,true)})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }